<template>
  <div
    class="modal fade ag-modal ag-user-modal"
    id="agPdpLrpModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="ag-modal"
    aria-hidden="true"
    data-backdrop="static"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">

          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
          <div class="modal-title-container">
            <h3 v-if="!formValues.id">{{ $t("addPdpLrp") }}</h3>
            <h3 v-if="formValues.id">{{ $t("editPdpLrp") }}</h3>
          </div>
        </div>


        <Form
          @submit="onSubmit"
          autocomplete="off"
          ref="form"
          :key="compKey"
          :initial-values="formValues"
          :validation-schema="schema"
          v-slot="{ meta }"
        >
          <input
            autocomplete="false"
            name="hidden"
            type="text"
            style="display: none"
          />
          <div class="modal-body">
            <div class="ag-modal-form w-100">
              <div class="pdp-description">
                <span>
                  {{ formValues.id ? $t("pdpLrpEditWarning") : null }}
                </span>
              </div>
              <div class="pdp-description">
                  <span>
                    {{ formValues.id ? $t("testConnectionBeforeSavingPdpLrp") : null }}
                  </span>
              </div>
            
              <ul class="ag-modal-form-list">
                <li>
                  <span class="bold-text">{{ $t("pdpLrpName") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="serverName" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="serverName"
                          maxlength="191"
                          v-model="formValues.serverName"
                          class="form-control"
                          :placeholder="$t('serverName')"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="pdpLrpName"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">{{ $t("url") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="urlHttp" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="urlHttp"
                          maxlength="191"
                          v-model="formValues.urlHttp"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="url"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li class="point-type">
                  <span class="bold-text" >{{ $t("pointType") }} :</span>
                  <span class="value">
                      <div class="point-type" style="gap: 5px;">
                          <Field name="pdpServer">
                              <input
                              type="checkbox"
                              v-model="formValues.pdpServer"
                              :checked="formValues.pdpServer"
                              />
                              {{ $t("pdp") }}
                          </Field>
                          <Field name="lrpServer">
                              <input
                              type="checkbox"
                              v-model="formValues.lrpServer"
                              :checked="formValues.lrpServer"
                              style="margin-left: 10px;"
                              />
                              {{ $t("lrp") }}
                          </Field>
                      </div>
                  </span>
                </li>
                <li>
                  <span class="bold-text">{{ $t("zone") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="" v-slot="{ field, meta }">
                        <select
                          name=""
                          class="form-control"
                          v-bind="field"
                          v-model="formValues.zonesId"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        >
                        <option
                          v-for="(item, key) in zones"
                          :key="key"
                          :value="item.id"
                        >
                          {{ item.name }}
                        </option>
                      </select>
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name=""
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
                  <span class="bold-text">{{ $t("agmsUserId") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="egmcUserID" v-slot="{ field, meta }">
                        <input
                          type="text"
                          name="egmcUserID"
                          maxlength="191"
                          v-model="formValues.egmcUserID"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="egmcUserID"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                </li>
                <li>
              <span class="bold-text">{{ $t("agmsPassword") }} : </span>
                <span class="value">
                    <li class="form-group form-group-full">
                        <Field name="egmcPassword" v-slot="{ field, meta }">
                            <div class="position-relative">
                                <input
                                    :type="!showAgmsPass ? 'password' : 'text'"
                                    name="egmcPassword"
                                    v-model="formValues.egmcPassword"
                                    class="form-control"
                                    v-bind="field"
                                    :class="{
                                        'form-error-input': meta.touched && !meta.valid,
                                    }"
                                />
                                <a
                                    href="javascript:;"
                                    class="generate-btn show-hide-btn"
                                    @click="showHideAgmsPassword()"
                                >
                                    <i class="ag-icon ag-icon_show mr-2" v-if="!showAgmsPass"></i>
                                    <i class="ag-icon ag-icon_hide mr-2" v-if="showAgmsPass"></i>
                                </a>
                                <div class="error-wrapper-new">
                                    <error-message class="form-error-label" name="egmcPassword"></error-message>
                                </div>
                            </div>
                        </Field>
                    </li>
                    <span class="bold-text ml-1">{{ $t("confirm") }}:</span>
                    <li class="form-group form-group-full">
                      <Field name="egmcConfirm" v-slot="{ field, meta }">
                          <div class="position-relative">
                              <input
                                  :type="!showAgmsConfirmPass ? 'password' : 'text'"
                                  name="egmcConfirm"
                                  v-model="formValues.egmcConfirm"
                                  class="form-control"
                                  v-bind="field"
                                  :class="{
                                      'form-error-input': meta.touched && !meta.valid,
                                  }"
                              />
                              <a
                                  href="javascript:;"
                                  class="generate-btn show-hide-btn"
                                  @click="showHideConfirmAgmsPassword()"
                              >
                                  <i class="ag-icon ag-icon_show mr-2" v-if="!showAgmsConfirmPass"></i>
                                  <i class="ag-icon ag-icon_hide mr-2" v-if="showAgmsConfirmPass"></i>
                              </a>
                              <div class="error-wrapper-new">
                                  <error-message class="form-error-label" name="egmcConfirm"></error-message>
                              </div>
                          </div>
                      </Field>
                    </li>
                    </span>
                  </li>
                  <li
                    :style="{ marginTop: hasAgmsConfirmError ? '30px' : '0px' }"
                  >
                    <span class="bold-text">{{ $t("agentUserId") }} : </span>
                    <span class="value">
                      <li class="form-group form-group-full">
      <Field name="agentUserID" v-slot="{ field, meta }">
        <input
          type="text"
          name="agentUserID"
          maxlength="191"
          v-model="formValues.agentUserID"
          class="form-control"
          v-bind="field"
          :class="{
            'form-error-input': meta.touched && !meta.valid,
          }"
        />
        <div class="error-wrapper">
          <error-message class="form-error-label" name="agentUserID"></error-message>
        </div>
      </Field>
                      </li>
                    </span>
                  </li>
                
                  <li>
                  <span class="bold-text">{{ $t("agentPassword") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="agentPassword" v-slot="{ field, meta }">
                          <div class="position-relative">
                        <input
                          :type="!showAgentPass ? 'password' : 'text'"
                          name="agentPassword"
                          maxlength="191"
                          v-model="formValues.agentPassword"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                          <a
                              href="javascript:;"
                              class="generate-btn show-hide-btn"
                              @click="showHideAgentPassword()"
                          >
                              <i
                              class="ag-icon ag-icon_show mr-2"
                              v-if="!showAgentPass"
                              ></i>
                              <i
                              class="ag-icon ag-icon_hide mr-2"
                              v-if="showAgentPass"
                              ></i>
                          </a>
                          <div class="error-wrapper-new">
                          <error-message
                            class="form-error-label"
                            name="agentPassword"
                          ></error-message>
                        </div>
                      </div>
                        
                      </Field>
                    </li>
                    <span class="bold-text ml-1">{{ $t("confirm") }}:</span>
                    <li class="form-group form-group-full">
                      <Field name="agentConfirm" v-slot="{ field, meta }">
                        <div class="position-relative">
                        <input
                          :type="!showAgentConfirmPass ? 'password' : 'text'"
                          name="agentConfirm"
                          maxlength="191"
                          v-model="formValues.agentConfirm"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <a
                              href="javascript:;"
                              class="generate-btn show-hide-btn"
                              @click="showHideAgentConfirmPassword()"
                          >
                              <i
                              class="ag-icon ag-icon_show mr-2"
                              v-if="!showAgentConfirmPass"
                              ></i>
                              <i
                              class="ag-icon ag-icon_hide mr-2"
                              v-if="showAgentConfirmPass"
                              ></i>
                          </a>
                          <div class="error-wrapper-new">
                          <error-message
                            class="form-error-label"
                            name="agentConfirm"
                          ></error-message>
                        </div>
                          </div>  
                        
                      </Field>
                    </li>
                  </span>
                  </li>
                  <li  :style="{ marginTop: hasAgmsConfirmError ? '30px' : '0px' }">
                  <span class="bold-text">{{ $t("priority") }} : </span>
                  <span class="value">
                    <li class="form-group form-group-full">
                      <Field name="priority" v-slot="{ field, meta }">
                        <input
                          type="number"
                          name="priority"
                          v-model="formValues.priority"
                          class="form-control"
                          v-bind="field"
                          :class="{
                            'form-error-input': meta.touched && !meta.valid,
                          }"
                        />
                        <div class="error-wrapper">
                          <error-message
                            class="form-error-label"
                            name="priority"
                          ></error-message>
                        </div>
                      </Field>
                    </li>
                  </span>
                  </li>
                  <li>
                    <span class="bold-text">{{ $t("setAsDefault") }} :</span>
                    <span class="value">
                    <div>
                      <Field name="default">
                        <input
                          type="checkbox"
                          v-model="formValues.defaultSettings"
                        />
                      </Field>
                    </div>
                    </span>
                  </li>
                
                </ul>
               
              </div>
          </div>
          <div class="modal-footer d-flex justify-content-between">
            <button
              type="button"
              class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_secondary"
              data-dismiss="modal"
            >
            {{ $t("cancel") }}
            </button>
            <div>
              <button
                  type="button"
                  class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary mr-2"
                  @click="testConnection"
                  :disabled="loading"
              >
              <span v-if="loading" class="spinner-border spinner-border-sm loading" role="status" aria-hidden="true"></span>
              {{ $t("testConnection") }}
              </button>
              <button
                  type="submit"
                  :disabled="!meta.valid || loading || !connectionTested"
                  class="border-0 ag-button ag-button_radius pr-4 pl-4 ag-button_primary"
              >
              {{ $t("save") }}
              </button>
            </div>
            
          </div>
        </Form>
      </div>
    </div>
  </div>
</template>

<script>
import { useStore } from "@/store"; 
import { notify } from "@kyvg/vue3-notification";
import { Roles } from "@/helpers/enums/Roles";
import apiAGSC from "@/store/axiosAgsc";
import { Field, Form, ErrorMessage } from "vee-validate";
import * as Yup from "yup";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import Swal from 'sweetalert2';
const store = useStore();

export default {
  name: "ag-pdp-lrp-modal",
  components: {
    Field,
    Form,
    ErrorMessage,
  },
  props: {
    selectedServer: Object,
    selectedRow: Object,
    zones: Array
  },
  data() {
    const schema = Yup.object().shape({
      serverName: Yup.string().required().label(this.$t("pdpLrpName")),
      urlHttp: Yup.string().required().label(this.$t("url")),
      egmcUserID: Yup.string().required().label(this.$t("agmsUserId")),
      egmcPassword: Yup.string().min(8, this.$t("passwordMinLength")).required().label(this.$t("agmsPassword")),
      egmcConfirm: Yup.string()
        .oneOf([Yup.ref("egmcPassword"), null], this.$t("passwordsMustMatch"))
        .required()
        .label(this.$t("confirm")),
      agentUserID: Yup.string().required().label(this.$t("agentUserId")),
      agentPassword: Yup.string().min(8, this.$t("passwordMinLength")).required().label(this.$t("agentPassword")),
      agentConfirm: Yup.string()
        .oneOf([Yup.ref("agentPassword"), null], this.$t("passwordsMustMatch"))
        .required()
        .label(this.$t("confirm")),
        });
    return {
      schema,
      loading: false,
      showAgmsPass: false,
      showAgmsConfirmPass: false,
      showAgentPass: false,
      showAgentConfirmPass: false,
      connectionTested: false,
      hasAgmsConfirmError: false,
      hasAgentConfirmError: false,
      Roles: Roles,
      formValues: {
        serverName: "",
        urlHttp: "",
        pdpServer: true,
        lrpServer: true,
        zonesId: "",
        egmcUserID: "",
        egmcPassword: "",
        egmcConfirm: "",
        agentUserID: "",
        agentPassword: "",
        agentConfirm: "",
        priority: "",
      }
    };
  },
  watch: {
    selectedServer(server) {
      if (server && server.id) {
        this.formValues = { ...server };
        this.formValues.egmcConfirm = server.egmcPassword;
        this.formValues.agentConfirm = server.agentPassword;
        this.connectionTested = true;
      }
    },
    zones(zones) {
      console.log(zones);
    },
    selectedRow(row) {
      if (row && row.id) {
        this.formValues = { ...row };
        this.formValues.egmcConfirm = row.egmcPassword;
        this.formValues.agentConfirm = row.agentPassword;
        this.connectionTested = true;
      }
    },
    formValues: {
      deep: true,
      handler() {
        this.connectionTested = false;
      }
    },
    compKey() {
      this.showAgmsPass = false,
      this.showAgmsConfirmPass = false,
      this.showAgentPass = false,
      this.showAgentConfirmPass = false,

      this.connectionTested = true,
      this.formValues = {
        serverName: "",
        urlHttp: "",
        pdpServer: true,
        lrpServer: true,
        zonesId: "299ee969-7203-4122-ba11-8a4f66964d74",
        egmcUserID: "",
        egmcPassword: "",
        egmcConfirm: "",
        agentUserID: "",
        agentPassword: "",
        agentConfirm: "",
        priority: "",
      };
    },
  },
  computed: {
    compKey() {
      return store.getters.compKey;
    },
  },
  methods: {
    checkError() {
      const errorElement = document.querySelector(
        ".error-wrapper-new .form-error-label"
      );
      this.hasAgmsConfirmError =
        errorElement && errorElement.innerText.trim() !== "";
    },
    async testConnection() {
      this.loading = true;
      const payload = { ...this.formValues }; 
      const res = await this.$parent.testConnection(payload);
      if (res === "success") {
        this.connectionTested = true; 
      } 
      this.loading = false;
    },

    closeAllModals() {
      const modals = document.getElementsByClassName("modal");

      for (let i = 0; i < modals.length; i++) {
        modals[i].classList.remove("show");
        modals[i].setAttribute("aria-hidden", "true");
        modals[i].setAttribute("style", "display: none");
      }

      const modalsBackdrops = document.getElementsByClassName("modal-backdrop");

      for (let i = 0; i < modalsBackdrops.length; i++) {
        document.body.removeChild(modalsBackdrops[i]);
      }
    },
    async onSubmit() {
      if (!this.connectionTested){
        notify({
          title: this.$t('sthWentWrong'),
          text: this.$t('testYourConnection'),
          type: "warning",
          duration: 4000,
        });
        return;
      }
      const body = this.formValues;
      apiAGSC["post"]("Server/CreateOrUpdateServer", body)
        .then((res) => {
          let errors = [];
          if (res.status && res.status !== 200 && res.data.errors) {
            errors = res.data.errors;
          } else if (
            
            res.data.statusCode &&
            res.data.statusCode !== 200 &&
            res.data.errors
          ) {
            errors = res.data.errors;
          }
          if (errors.length > 0) {
            const errorMessage = errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: this.$t('errorOccurred'),
              type: "error",
              text:
                "<p>" +
                res.data.Message +
                "</p>" +
                "<ul>" +
                errorMessage +
                "</ul>",
              duration: 8000,
            });
          } else {
            this.$emit("formsuccess");
            this.closeAllModals();
            let message = '';
         
            if (res.data.entityData.defaultSettingsCheck) {
              message += this.$t('defaultSettingsCheck');
            }
            if (res.data.entityData.pdpServerCheck) {
              if (message) {
                message += '<br>';
              }
              message += this.$t('pdpServerCheck');
            }
            if (res.data.entityData.lrpServerCheck) {
              if (message) {
                message += '<br>';
              }
              message += this.$t('lrpServerCheck');
            }
            if (message) {
            Swal.fire("Info", message, "info");
            }
            else {
              if (res.data.entityData.isServerNameExists) {
              notify({
                title:
                   this.$t('isServerNameExists'),
                type: "error",
                duration: 4000,
              });
            }
            else{
              notify({
              title:
               this.selectedServer.id 
                  ? this.$t('updateServer')
                  : this.$t('addServer'),
              type: "success",
              duration: 4000,
            });
            }
              
            }
            
            store.dispatch(
              GeneralActionTypes.SET_COMPKEY,
              store.getters.compKey + 1
            );
            store.dispatch(GeneralActionTypes.GET_SERVERS, {
              options: {
                sortable: {
                  order: "serverName",
                  sortDir: "asc",
                },
                total: 0,
                page: 1,
                pageSize: 5,
              },
              filters: {},
            });
          }
        })
        .catch((e) => {
          if (e && e.errors) {
            const errors = e.errors.map((f) => "<li>" + f + "</li>");
            notify({
              title: this.$t('errorOccurred'),
              type: "error",
              text: "<p>" + e.message + "</p>" + "<ul>" + errors + "</ul>",
              duration: 8000,
            });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    showHideAgmsPassword() {
      this.showAgmsPass = !this.showAgmsPass;
    },
    showHideConfirmAgmsPassword() {
      this.showAgmsConfirmPass = !this.showAgmsConfirmPass;
    },
    showHideAgentPassword() {
      this.showAgentPass = !this.showAgentPass;
    },
    showHideAgentConfirmPassword() {
      this.showAgentConfirmPass = !this.showAgentConfirmPass;
    },
  },
  mounted() {
    this.checkError();
    setInterval(this.checkError, 1);
},
};
</script>

<style lang="scss" scoped>
.ag-modal .modal-body label {
  color: #8e8e8e;
  font-size: 14px;
  margin: 0;
  display: flex;
  align-items: center;
}

.ag-modal-form-list {
  margin-left: 54px;
}

.ag-modal .modal-body label input {
  margin-right: 4px;
}

.ag-modal-form-list li {
  width: 86%;
}

.ag-modal-form-list li .bold-text {
  text-align: left !important;
  width: 33% !important;
}

.error-wrapper {
  display: block;
  width: 100%;
}

li.form-group-full {
  display: flex;
  flex-direction: column;
}

.generate-btn {
  position: absolute;
  top: 8px;
  font-size: 13px;
  &.show-hide-btn {
    right: 1px;
  }
}

.loading {
  margin-bottom: 3px;
  margin-right: 4px;
}

.position-relative {
  width: 100%;
  display: block;
}

.point-type {
  display: flex; 
  align-items: center;
}

.pdp-description {
  font-size: 15px;
  color: #FF8C00;
  text-align: center;
}
.modal-header {
display: flex;
align-items: center;
justify-content: space-between; 
position: relative;
}

.modal-header {
display: flex;
justify-content: center; 
align-items: center;
position: relative;
}

.modal-header h3 {
font: normal normal 600 26px/42px;
letter-spacing: 0px;
color: #5e5e5e;
font-weight: bold;
text-align: center;
margin: 0; 
}

.close {
position: absolute;
right: 15px;
top: 15px;
}

.error-wrapper-new {
  position: absolute;
  bottom: -20px;
  left: 0;
  width: 100%;
  height: 20px; 
}
li{
  height: 60px;
}
</style>
